import {Inject, Injectable} from '@angular/core';

@Injectable({
  providedIn: "root"
})
export class StorageService {
  constructor() {}
  getItem(key: string): any {}
  setItem(key: string, value: string) {}
  removeItem(key: string) {}
  clear() {}
}
